/* eslint-disable */
import * as actionTypes from './constants';
import { filterType, filterStatus, filterProvider, filterSubcategory } from './filters';
import { categoryModifierFormatted, categoryModifierChangeShowHide } from '../helpers/categoryModifiers';
import { modifierServicesListFilter } from '../helpers/listModifiers';
import { CHANGE_FILTER_SUBCATEGORY } from './constants';

// Init state
export const serviceTableState = {
  isLoadingTable: false,
  search: '',
  searchOption: null,
  filters: {
    subcategory: {
      func: filterSubcategory,
      value: null,
    },
    type: {
      func: filterType,
      value: null,
    },
    provider: {
      func: filterProvider,
      value: null,
    },
    status: {
      func: filterStatus,
      value: null,
    },
  },
  scrollToCategoryId: null,
  scrollToServiceId: null,
  toggleCategories: true,
  toggleCategoryID: null,
  highlightServices: [],
  highlightCategories: [],
  modal: null,
  startList: [],
  list: [],
  sortCategoryStart: {}
};

// Reducer
export const serviceTableReducer = (state, action) => {
  switch (action.type) {
  case actionTypes.INIT:
    const list = modifierServicesListFilter(
      action.categories,
      state.filters,
      state.search,
      state.searchOption,
      state.highlightServices,
      state.highlightCategories,
    );
    return {
      ...state,
      startList: action.categories.map((category, categoryIndex) => {
        if (category.hasOwnProperty('services')) {
          return {
            ...category,
            services: category.services.map((service) => {
              return {
                ...service,
                startListCategoryIndex: categoryIndex
              }
            })
          }
        }
        return category
      }),
      list,
      listCount: list?.filter((item) => item.collection !== 'category')?.length || 0,
    };
  case actionTypes.CHANGE_START:
    return {
      ...state,
      sortCategoryStart: {
        index: action.payload.category_id,
        category_id: action.payload.category_id,
        list: state.list,
        startList: state.startList
      },
      startList: state.startList
        .filter((item) => {
          if (!state.toggleCategories) {
            return true;
          }
          if (action.payload.index !== 0) {
            return item.id !== action.payload.category_id;
          }
          return true;
        })
        .map((category) => ({
        ...category,
        show: false,
      })),
    }
  case actionTypes.LOADING:
    return {
      ...state,
      isLoadingTable: true,
    };
  case actionTypes.CHANGE_SEARCH:
    return {
      ...state,
      isLoadingTable: true,
      search: action.value,
    };
  case actionTypes.CHANGE_SEARCH_OPTION:
    return {
      ...state,
      isLoadingTable: !!state.search,
      searchOption: action.value,
    };
  case actionTypes.CHANGE_FILTER_STATUS:
    return {
      ...state,
      isLoadingTable: true,
      filters: {
        ...state.filters,
        status: {
          ...state.filters.status,
          value: action.value,
        },
      },
    };
  case actionTypes.CHANGE_FILTER_TYPE:
    return {
      ...state,
      isLoadingTable: true,
      filters: {
        ...state.filters,
        type: {
          ...state.filters.type,
          value: action.value,
        },
      },
    };
    case actionTypes.CHANGE_FILTER_SUBCATEGORY:
      return {
        ...state,
        isLoadingTable: true,
        filters: {
          ...state.filters,
          subcategory: {
            ...state.filters.subcategory,
            value: action.value,
          },
        },
      };
  case actionTypes.CHANGE_FILTER_PROVIDER:
    return {
      ...state,
      isLoadingTable: true,
      filters: {
        ...state.filters,
        provider: {
          ...state.filters.provider,
          value: action.value,
        },
      },
    };
  case actionTypes.UPDATE_LIST:
    const updatedList = modifierServicesListFilter(
      state.startList,
      state.filters,
      state.search,
      state.searchOption,
      state.highlightServices,
      state.highlightCategories,
    );
    return {
      ...state,
      isLoadingTable: false,
      toggleCategoryID: null,
      list: updatedList,
      listCount: updatedList?.filter((item) => item.collection !== 'category')?.length || 0,
    };
  case actionTypes.UPDATE_CATEGORIES_LIST:
    return {
      ...state,
      startList: action.categories,
    };
  case actionTypes.TOGGLE_CATEGORIES:
    return {
      ...state,
      isLoadingTable: true,
      toggleCategories: action.show,
      startList: state.startList.map((category) => ({
        ...category,
        show: action.show,
      })),
    };
  case actionTypes.SHOW_CATEGORY:
  case actionTypes.HIDE_CATEGORY:
    return {
      ...state,
      isLoadingTable: true,
      toggleCategoryID: action.id,
      startList: categoryModifierChangeShowHide(state.startList, action.id),
    };
  case actionTypes.MODAL_OPEN:
    return {
      ...state,
      modal: {
        name: action.name,
        data: action.data,
      },
    };
  case actionTypes.MODAL_CLOSE:
    return {
      ...state,
      modal: null,
    };
  case actionTypes.CHANGE_SERVICE_STATUS:
    return {
      ...state,
      isLoadingTable: true,
    };
  case actionTypes.MASS_SERVICES_DELETE:
  case actionTypes.SERVICES_MASS_ASSIGN_CATEGORY:
  case actionTypes.SERVICES_MASS_CHANGE_STATUS:
  case actionTypes.SERVICES_MASS_CHANGE_DRIP_FEED:
  case actionTypes.SERVICES_MASS_RESET_CUSTOM_RATES:
  case actionTypes.SERVICES_UPDATE_RATE_SUCCESS:
    return {
      ...state,
      isLoadingTable: true,
      modal: null,
      highlightServices: action.list,
    };
  case actionTypes.DUPLICATE:
  case actionTypes.CHANGE_SERVICE_STATUS_SUCCESS:
  case actionTypes.EDIT_DESCRIPTION:
  case actionTypes.RESET_CUSTOM_RATE:
    case actionTypes.SERVICES_CHANGE_POSITION_SERVICE:
    return {
      ...state,
      isLoadingTable: true,
      modal: null,
      highlightServices: [action.id],
      sortCategoryStart: {}
    };
  case actionTypes.SERVICES_EDIT_SUCCESS:
    return {
      ...state,
      isLoadingTable: true,
      modal: null,
      highlightServices: [action.id],
      scrollToServiceId: action.id,
    };
  case actionTypes.IMPORT_SERVICES:
    return {
      ...state,
      isLoadingTable: true,
      highlightServices: action.list,
      modal: null,
    };
  case actionTypes.DELETE:
    return {
      ...state,
      isLoadingTable: true,
      modal: null,
      highlightServices: [action.id],
    };
  case actionTypes.CLEAR_HIGHLIGHT_SERVICES:
    return {
      ...state,
      highlightServices: [],
    };
  case actionTypes.CLEAR_HIGHLIGHT_CATEGORIES:
    return {
      ...state,
      highlightCategories: [],
    };
  case actionTypes.EDIT_CATEGORY:
  case actionTypes.DELETE_CATEGORY:
  case actionTypes.CATEGORY_CHANGE_VISIBILITY:
  case actionTypes.SERVICES_CHANGE_POSITION_CATEGORY:
    return {
      ...state,
      isLoadingTable: true,
      modal: null,
      highlightCategories: [action.id],
      sortCategoryStart: {}
    };
  case actionTypes.CATEGORY_CREATE:
    return {
      ...state,
      isLoadingTable: true,
      modal: null,
      scrollToCategoryId: action.id,
      highlightCategories: [action.id],
    };
  case actionTypes.SERVICES_CHANGE_POSITION_ERROR:
  case actionTypes.SERVICES_UPDATE_RATE_ERROR:
  case actionTypes.CHANGE_SERVICE_STATUS_ERROR:
    return {
      ...state,
      isLoadingTable: false,
    };
  case actionTypes.SERVICES_CHANGE_POSITION_CATEGORY_ERROR:
    return {
      ...state,
      isLoadingTable: false,
      list: state.sortCategoryStart?.list || state.list,
      startList: state.sortCategoryStart?.startList || state.startList,
      sortCategoryStart: {}
    };
  case actionTypes.CLEAR_HIGHLIGHTS:
    return {
      ...state,
      highlightServices: [],
      highlightCategories: [],
    };
  case actionTypes.CLEAR_SCROLLS:
    return {
      ...state,
      scrollToCategoryId: null,
      scrollToServiceId: null,
    };
  default:
    throw new Error();
  }
};

// Action creator
export function changeSearch(value) {
  return { type: actionTypes.CHANGE_SEARCH, value };
}

export function changeSearchOption(value) {
  return { type: actionTypes.CHANGE_SEARCH_OPTION, value };
}

export function changeFilterStatus(value) {
  return { type: actionTypes.CHANGE_FILTER_STATUS, value };
}

export function changeFilterType(value) {
  return { type: actionTypes.CHANGE_FILTER_TYPE, value };
}

export function changeFilterSubcategory(value) {
  return { type: actionTypes.CHANGE_FILTER_SUBCATEGORY, value };
}

export function changeFilterProvider(value) {
  return { type: actionTypes.CHANGE_FILTER_PROVIDER, value };
}

export function showCategory(id) {
  return { type: actionTypes.SHOW_CATEGORY, id };
}

export function hideCategory(id) {
  return { type: actionTypes.HIDE_CATEGORY, id };
}

export function changeToggleCategories(show) {
  return { type: actionTypes.TOGGLE_CATEGORIES, show };
}

export function openModal(name, data) {
  return { type: actionTypes.MODAL_OPEN, name, data };
}

export function closeModal() {
  return { type: actionTypes.MODAL_CLOSE };
}

export function duplicateService(id) {
  return { type: actionTypes.DUPLICATE, id };
}

export function deleteService(id) {
  return { type: actionTypes.DELETE, id };
}

export function importServicesSuccess(list) {
  return { type: actionTypes.IMPORT_SERVICES, list };
}

export function massDeleteServices(list) {
  return { type: actionTypes.MASS_SERVICES_DELETE, list };
}

export function massChangeStatus(list) {
  return { type: actionTypes.SERVICES_MASS_CHANGE_STATUS, list };
}

export function massAssignCategory(list) {
  return { type: actionTypes.SERVICES_MASS_ASSIGN_CATEGORY, list };
}

export function massResetCustomRates(list) {
  return { type: actionTypes.SERVICES_MASS_RESET_CUSTOM_RATES, list };
}

export function clearHighlightServices() {
  return { type: actionTypes.CLEAR_HIGHLIGHT_SERVICES };
}

export function clearHighlightCategories() {
  return { type: actionTypes.CLEAR_HIGHLIGHT_CATEGORIES };
}

export function clearHighlights() {
  return { type: actionTypes.CLEAR_HIGHLIGHTS };
}

export function clearScrolls() {
  return { type: actionTypes.CLEAR_SCROLLS };
}

export function changeServiceStatus() {
  return { type: actionTypes.CHANGE_SERVICE_STATUS };
}

export function changeServiceStatusSuccess(id) {
  return { type: actionTypes.CHANGE_SERVICE_STATUS_SUCCESS, id };
}

export function changeServiceStatusError() {
  return { type: actionTypes.CHANGE_SERVICE_STATUS_ERROR };
}

export function updateList() {
  return { type: actionTypes.UPDATE_LIST };
}

export function updateCategoriesList(newCategories, oldCategories) {
  return { type: actionTypes.UPDATE_CATEGORIES_LIST, categories: categoryModifierFormatted(newCategories, oldCategories) };
}

export function serviceTableLoading() {
  return { type: actionTypes.LOADING };
}

export function editCategory(id) {
  return { type: actionTypes.EDIT_CATEGORY, id };
}

export function createCategory(id) {
  return { type: actionTypes.CATEGORY_CREATE, id };
}

export function deleteCategory(id) {
  return { type: actionTypes.DELETE_CATEGORY, id };
}

export function editDescription(id) {
  return { type: actionTypes.EDIT_DESCRIPTION, id };
}

export function resetCustomRate(id) {
  return { type: actionTypes.RESET_CUSTOM_RATE, id };
}

export function categoryChangeVisibility(id) {
  return { type: actionTypes.CATEGORY_CHANGE_VISIBILITY, id };
}

export function changePositionCategory(id) {
  return { type: actionTypes.SERVICES_CHANGE_POSITION_CATEGORY, id };
}

export function changePositionCategoryError() {
  return { type: actionTypes.SERVICES_CHANGE_POSITION_CATEGORY_ERROR };
}

export function changePositionService(id) {
  return { type: actionTypes.SERVICES_CHANGE_POSITION_SERVICE, id };
}

export function changePositionError() {
  return { type: actionTypes.SERVICES_CHANGE_POSITION_ERROR };
}

export function updateRateSuccess(list) {
  return { type: actionTypes.SERVICES_UPDATE_RATE_SUCCESS, list };
}

export function editService(id) {
  return { type: actionTypes.SERVICES_EDIT_SUCCESS, id };
}

export function updateRateError() {
  return { type: actionTypes.SERVICES_UPDATE_RATE_ERROR };
}

export function initServiceReducer(categories) {
  return {
    type: actionTypes.INIT,
    categories: categoryModifierFormatted(categories, []),
  };
}

export function massChangeDripFeed(list) {
  return { type: actionTypes.SERVICES_MASS_CHANGE_DRIP_FEED, list };
}
